import React, { useRef, useState, useEffect } from 'react';
import emailjs from "@emailjs/browser";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ContactForm = () => {
  const form = useRef();
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    const formData = new FormData(form.current);
    const first = formData.get("first");
    const email = formData.get("email");
    const message = formData.get("message");

    const newErrors = {};
    if (!first) newErrors.first = "Required";
    if (!email) newErrors.email = "Required";
    if (!message) newErrors.message = "Required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    emailjs
      .sendForm("service_v0ixkvg", "template_k1ber48", form.current, "Q6f9GBolsWJq-DMj0")
      .then(
        () => {
          setSuccess(true);
          form.current.reset();
        },
        (error) => {
          console.error("Email send error:", error.text);
        }
      );
  };

  return (
    <section className="px-6 py-16 lg:px-20 bg-white mt-24">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16">
        {/* Form Section */}
        <div>
          {loading ? (
            <>
              <Skeleton height={36} width={180} className="mb-2" style={{ borderRadius: 8 }} />
              <Skeleton height={20} width={260} className="mb-8" style={{ borderRadius: 8 }} />
              {/* Name */}
              <Skeleton height={20} width={80} className="mb-2" />
              <div className="flex gap-4 mb-4">
                <Skeleton height={40} className="w-full" style={{ borderRadius: 8 }} />
                <Skeleton height={40} className="w-full" style={{ borderRadius: 8 }} />
              </div>
              {/* Email */}
              <Skeleton height={20} width={80} className="mb-2" />
              <Skeleton height={40} className="w-full mb-4" style={{ borderRadius: 8 }} />
              {/* Message */}
              <Skeleton height={20} width={80} className="mb-2" />
              <Skeleton height={100} className="w-full mb-4" style={{ borderRadius: 8 }} />
              {/* Button */}
              <Skeleton height={40} width={160} style={{ borderRadius: 20, margin: '0 auto' }} />
            </>
          ) : (
            <>
              <h2 className="text-3xl font-bold text-[#003A7D]">CONTACT</h2>
              <p className="text-sm text-gray-700 mt-2 mb-8">
                Let's discuss about your next project.
              </p>

              <form ref={form} onSubmit={sendEmail} className="space-y-6">
                {/* Name */}
                <div>
                  <label className="font-medium">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4 mt-1">
                    <input
                      name="first"
                      placeholder="First"
                      className="border p-2 w-full"
                    />
                    <input
                      name="last"
                      placeholder="Last"
                      className="border p-2 w-full"
                    />
                  </div>
                  {errors.first && (
                    <p className="text-red-500 text-sm mt-1">First name is required.</p>
                  )}
                </div>

                {/* Email */}
                <div>
                  <label className="font-medium">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="border p-2 w-full mt-1"
                    placeholder="your@email.com"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">Email is required.</p>
                  )}
                </div>

                {/* Message */}
                <div>
                  <label className="font-medium">
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="message"
                    rows="5"
                    className="border p-2 w-full mt-1"
                  ></textarea>
                  {errors.message && (
                    <p className="text-red-500 text-sm mt-1">Message is required.</p>
                  )}
                </div>

                <button
                  type="submit"
                  className="bg-[#003A7D] text-white px-6 py-2 font-semibold text-sm hover:bg-[#002060] transition duration-300"
                >
                  SEND MESSAGE
                </button>

                {success && (
                  <p className="text-green-600 font-medium mt-4">
                    Message sent successfully!
                  </p>
                )}
              </form>
            </>
          )}
        </div>

        {/* Contact Info */}
        <div>
          {loading ? (
            <>
              <Skeleton height={28} width={120} className="mb-6" />
              <Skeleton height={20} width={80} className="mb-2" />
              <Skeleton height={16} width={180} className="mb-1" />
              <Skeleton height={16} width={180} className="mb-1" />
              <Skeleton height={16} width={220} className="mb-2" />
              <Skeleton height={20} width={80} className="mb-2" />
              <Skeleton height={16} width={120} className="mb-1" />
              <Skeleton height={16} width={180} className="mb-1" />
            </>
          ) : (
            <>
              <h3 className="text-xl font-semibold text-[#003A7D] mb-6">Find us</h3>
              <div className="mb-6">
                <h4 className="font-semibold mb-1">Contact</h4>
                <p className="text-sm">
                  <a href="tel:+251116660544" className="hover:underline">+251-116-660-544</a>
                </p>
                <p className="text-sm">
                  <a href="tel:+251911208646" className="hover:underline">+251-911-208-646</a>
                </p>
                <p className="text-sm">
                  <a href="mailto:yetwinscon@gmail.com" className="hover:underline">yetwinscon@gmail.com</a>
                </p>
              </div>
              <div>
                <h4 className="font-semibold mb-1">Office</h4>
                <p className="text-sm">Hibir Building, 6th Floor</p>
                <p className="text-sm">Gurd Shola Road</p>
                <p className="text-sm">Addis Ababa, Ethiopia</p>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactForm; 